// Shared `YYYY-MM-DD HH:MM:SS` formatter for Role timestamps (PRD 16 §4.1 —
// createdAt/updatedAt are specified in exactly this format).
//
// Extracted from RoleListRow for SHCT-633: the detail screen must print the same
// two dates as the list, and two copies of the formatting would be free to drift.
// `new Date(iso)` + the local getters render in the browser's zone, which is KST
// for this product — the same conversion the list has always done.

const pad = (n: number) => String(n).padStart(2, '0');

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
